module.exports = __webpack_public_path__ + "media/images/flags/32/Netherlands-13b0afb5dab824e18f570a73e20ed982.png";